import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useMatchRoute } from "@tanstack/react-router";

import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

import type { PathKey } from "./NavLinkWrapper";
import { NavLinkWrapper } from "./NavLinkWrapper";

export interface LinkItemProps {
  icon: IconType;
  label: string;
  path: string;
  pathKey?: PathKey;
  shouldShowUnreadCount?: boolean;
  unreadCount?: number;
}

export const LinkItem = ({
  label,
  path,
  icon,
  pathKey,
  shouldShowUnreadCount,
  unreadCount = 0,
}: LinkItemProps) => {
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();
  const matchRoute = useMatchRoute();
  const isRouteMatch = Boolean(matchRoute({ to: path }));

  return (
    <TippyV2
      interactive={false}
      key={label}
      content={label}
      placement="right"
      arrow={false}
    >
      <div
        className={classNames("relative", {
          "w-full": isMemberAreaAppShellEnabled,
        })}
      >
        <NavLinkWrapper path={path} pathKey={pathKey}>
          {shouldShowUnreadCount && unreadCount > 0 && (
            <div className="border-tertiary absolute -right-2 -top-2 flex size-6 items-center justify-center rounded-full border-2 bg-[#15803D]">
              <Typography.LabelXxs color="text-white">
                {unreadCount}
              </Typography.LabelXxs>
            </div>
          )}
          <Icon
            type={icon}
            className={classNames({
              "text-default": !isRouteMatch,
              "text-selector-active": isRouteMatch,
            })}
            size={20}
          />
        </NavLinkWrapper>
      </div>
    </TippyV2>
  );
};
